export enum Role {
  ANY = "all",
  USER = "user",
  ADMIN = "admin",
}
